<template>
  <v-dialog :model-value="modelValue" max-width="680px" persistent @update:model-value="$emit('update:modelValue', $event)">
    <v-card class="dialog-card">
      <v-card-title class="dialog-title">Administrar tipos de lugar</v-card-title>
      <v-card-text>
        <v-alert type="info" variant="tonal" class="mb-4">
          Estos tipos se usan para mostrar solo los lugares adecuados en cada selector.
        </v-alert>
        <v-form v-if="canCreate || canUpdate" ref="form" @submit.prevent="save">
          <div class="d-flex ga-2 align-start">
            <v-text-field v-model="edited.name" label="Nombre del tipo" maxlength="80" :rules="[required]" autofocus/>
            <v-btn v-if="edited.id ? canUpdate : canCreate" type="submit" color="primary" :loading="saving">{{ edited.id ? 'Guardar' : 'Agregar' }}</v-btn>
            <v-btn v-if="edited.id" variant="text" @click="reset">Cancelar</v-btn>
          </div>
        </v-form>
        <v-alert v-if="error" type="error" variant="tonal" class="mb-3">{{ error }}</v-alert>
        <v-data-table :items="getLocationTypes" :headers="headers" :loading="loading" :items-per-page="-1" hide-default-footer no-data-text="No hay tipos de lugar.">
          <template #[`item.actions`]="{ item }">
            <div class="action-cell">
              <v-btn v-if="canUpdate" icon size="small" variant="text" aria-label="Editar tipo" @click="edit(item)"><v-icon>edit</v-icon></v-btn>
              <v-btn v-if="canDelete" icon size="small" variant="text" color="error" aria-label="Eliminar tipo" @click="remove(item)"><v-icon>delete</v-icon></v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions><v-spacer/><v-btn color="primary" @click="close">Cerrar</v-btn></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LocationTypeManager',
  props: { modelValue: Boolean },
  emits: ['update:modelValue', 'changed'],
  data: () => ({
    edited: { id: null, name: '' },
    loading: false,
    saving: false,
    error: '',
    required: value => !!value?.trim() || 'El nombre es obligatorio.',
    headers: [
      { title: 'Tipo', key: 'name' },
      { title: 'Acciones', key: 'actions', sortable: false, align: 'end' }
    ]
  }),
  computed: {
    ...mapGetters('locationModule', ['getLocationTypes']),
    ...mapGetters('authModule', ['hasPermission']),
    canCreate () { return this.hasPermission('catalog.location_types.create') },
    canUpdate () { return this.hasPermission('catalog.location_types.update') },
    canDelete () { return this.hasPermission('catalog.location_types.delete') }
  },
  watch: {
    modelValue (open) {
      if (open) this.load()
    }
  },
  methods: {
    async load () {
      this.loading = true
      this.error = ''
      try {
        await this.$store.dispatch('locationModule/getLocationTypes')
      } catch (error) {
        this.error = 'No se pudieron cargar los tipos de lugar.'
      } finally {
        this.loading = false
      }
    },
    edit (item) {
      this.edited = { id: item.id, name: item.name }
      this.error = ''
    },
    reset () {
      this.edited = { id: null, name: '' }
      this.error = ''
      this.$refs.form?.resetValidation()
    },
    async save () {
      const validation = await this.$refs.form.validate()
      if (!validation.valid || this.saving) return
      this.saving = true
      this.error = ''
      try {
        await this.$store.dispatch('locationModule/saveLocationType', this.edited)
        await this.load()
        this.$emit('changed')
        this.reset()
      } catch (error) {
        this.error = error.response?.status === 409 ? 'Ya existe un tipo con ese nombre.' : 'No se pudo guardar el tipo.'
      } finally {
        this.saving = false
      }
    },
    async remove (item) {
      if (!confirm(`¿Eliminar el tipo ${item.name}? Se quitará de los lugares que lo tengan asignado.`)) return
      this.error = ''
      try {
        await this.$store.dispatch('locationModule/removeLocationType', item.id)
        await this.load()
        this.$emit('changed')
        if (this.edited.id === item.id) this.reset()
      } catch (error) {
        this.error = 'No se pudo eliminar el tipo.'
      }
    },
    close () {
      this.reset()
      this.$emit('update:modelValue', false)
    }
  }
}
</script>
